module.exports = __webpack_public_path__ + "img/2172.d1748aab.gif";